var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 15.8086C15.1016 15.8086 15.875 15.0703 15.875 14.1211V1.74609C15.875 0.832031 15.1016 0.0585938 14.1875 0.0585938H1.8125C0.863281 0.0585938 0.125 0.832031 0.125 1.74609V14.1211C0.125 15.0703 0.863281 15.8086 1.8125 15.8086H14.1875ZM6.98047 12.3633C6.76953 12.6094 6.38281 12.6094 6.17188 12.3633L2.51562 8.70703C2.30469 8.49609 2.30469 8.14453 2.51562 7.93359L3.32422 7.125C3.53516 6.91406 3.88672 6.91406 4.09766 7.125L6.59375 9.58594L11.8672 4.3125C12.0781 4.10156 12.4297 4.10156 12.6406 4.3125L13.4492 5.12109C13.6602 5.33203 13.6602 5.68359 13.4492 5.89453L6.98047 12.3633Z",
    fill: "#025652"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/TickIcon.93e42ff0.svg";
export { ForwardRef as ReactComponent };